import React from "react";
import { withRouter } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Navigation from "../Navigation/Navigation";
import { signIn, signOut } from "../../redux/authentication/actions";
import { Toolbar, Button, Box, Tooltip } from "@material-ui/core";
import "./Header.css";



const Header = ({ history }) => {
    const { t } = useTranslation();
    const account = useSelector(state => state.authentication.account);
    const clientId = useSelector(state => state.configuration.clientId);
    const dispatch = useDispatch();

    return (
        <Toolbar className="main-toolbar">
            <Box className="left-box">
                <img src="/resources/HeaderLogo.png" alt=""/>
            </Box>
            <Box className="middle-box">
                <Navigation/>
            </Box>
            <Box className="right-box">
                {account ? (
                    <Tooltip  title={account.userName} placement="left" >
                        <Button variant="contained" onClick={() => dispatch(signOut())}>
                            {t("Header.signout")}
                        </Button>
                    </Tooltip>
                ) : (
                    <Button
                        variant="contained"
                        onClick={() => dispatch(signIn(history))}
                        visible={(!clientId).toString()}
                    >
                        {t("Header.signin")}
                    </Button>
                )}
            </Box>
        </Toolbar>
    );
};

export default withRouter(Header);
